// removed by extract-text-webpack-plugin
module.exports = {"home":"home__2-7ks","container":"container__3xiv0","desktop":"desktop__uOGiY","mobile":"mobile__3A7lx"};


//////////////////
// WEBPACK FOOTER
// ./routes/page-not-found/style.css
// module id = Lpmg
// module chunks = 253 312